'use client'

import React, { useState } from 'react'
import { Text } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { useIsDesktop } from '@/_hooks/useBreakpoint'
import type { IReview } from '@/_types'
import CommentDesktop from '@/app/[locale]/product/[slug]/_components/Comments/comment.desktop'
import CommentMobile from '@/app/[locale]/product/[slug]/_components/Comments/comment.mobile'

type Props = {
  reviews?: IReview[]
  count?: string | number
}

export default function Comments({ reviews = [], count }: Props) {
  const [isOpen, setOpen] = useState(false)
  const t = useTranslations()
  const isDesktop = useIsDesktop()
  const total = Number(count ?? reviews.length ?? 0)

  if (!total) {
    return (
      <Text opacity={0.2} fontWeight={500} fontSize="xs">
        {t('no_reviews')}
      </Text>
    )
  }

  return (
    <>
      <Text
        color="primary"
        fontSize="xs"
        fontWeight={500}
        cursor="pointer"
        onClick={() => setOpen(true)}
      >
        {total} {t('reviews')}
      </Text>
      {isDesktop ? (
        <CommentDesktop
          open={isOpen}
          onClose={() => setOpen(false)}
          reviews={reviews}
        />
      ) : (
        <CommentMobile
          isOpen={isOpen}
          onClose={() => setOpen(false)}
          reviews={reviews}
        />
      )}
    </>
  )
}
